import React, {useState} from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Header from './Header';
import Dashboard from './Dashboard';
import Occupation from './Occupation/Occupation'
import Footer from "./Footer";
import title from '../images/title.png';
import logo from "../images/logo.svg";


const useStyles = makeStyles((theme) => ({
  icon: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    width: '100%',
    height: 'auto'
  }
}));



export default function Main() {
  const classes = useStyles();
  const [selectedOccupation, setSelectedOccupation] = useState();

  const onSelectOccupation = (occ) => {
    setSelectedOccupation(occ);
  };

  const backToDashboard = () => {
    setSelectedOccupation(undefined);
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Header />
      <main>
        <div className={classes.heroContent}>
          <Container maxWidth="sm">
            <img src={logo} alt="Logo" className={classes.icon} width="100" height="100"/>
            <img src={title} alt="Title" width={600} className={classes.title}/>
            <Typography variant="h6" align="center" color="textPrimary">
              We will get through this together
            </Typography>
            <Typography variant="subtitle1" align="center" color="textSecondary">
              With the help from you
            </Typography>
          </Container>
        </div>
          {selectedOccupation ? <Occupation occupation={selectedOccupation}/>
          : <Dashboard onSelect={onSelectOccupation} goBack={backToDashboard}/>
          }
      </main>
      {!selectedOccupation ? <Footer />
        : null
      }
    </React.Fragment>
  );
}
